import { makeStyles } from '@mui/styles'
import PageMetaData from '@v4/utils/data/PageMetaData'

const useStyles = makeStyles(
	theme => ({
		root: {
			minHeight: theme.mixins.toolbar.minHeight,
			backgroundColor: 'inherit',
		},
		image: {
			display: 'flex',
			transition: theme.transitions.create(['all']),
			alignItems: 'center',
			maxHeight: '100%',
			minHeight: theme.spacing(8),
			height: 'auto',
			textAlign: 'center',
			maxWidth: ({ metaData }) => metaData.size?.toNumber(),
			'& img': {
				width: '100%',
				margin: '0 auto',
			},
		},
		text: {
			width: '100%',
		},
		textWrap: {},
		container: {
			width: '100%',
		},
		logoWrap: {
			marginLeft: 'auto',
			marginRight: 'auto',
			flexShrink: 0,
		},
		empty: {},
		[theme.breakpoints.down('sm')]: {
			empty: {
				display: 'none !important',
			},
			textWrap: {
				display: 'flex',
				justifyContent: 'center',
			},
			text: {
				textAlign: 'center',
			},
			[PageMetaData.ALIGNMENT.RIGHT]: {
				flexDirection: ({ metaData }) => (metaData.text?.metaValue ? 'column-reverse' : null),
			},
		},
		[theme.breakpoints.up('sm')]: {
			container: {
				flexWrap: 'nowrap',
			},
			[PageMetaData.ALIGNMENT.RIGHT]: {
				'& $logoWrap': {
					display: 'flex',
					flexDirection: 'row-reverse',
				},
			},
			[PageMetaData.ALIGNMENT.CENTER]: {
				'& $textWrap': {
					display: 'flex',
					justifyContent: 'flex-end',
				},
				'& $text': {
					textAlign: 'right',
				},
			},
		},
	}),
	{ name: 'Header' },
)

export default useStyles
